import React, { Fragment, useState } from "react";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";
import DropzoneElement from "../Dropzone/DropzoneElement";
import { type } from "../Dropzone/type";
import { FileUploadPromise } from "../../utils/aws_s3/aws_s3";
import ClipLoader from "react-spinners/ClipLoader";
import "./servicebulkimportmodal.scss";
import { connect } from "react-redux";

const ServiceBulkImportModal = (props) => {
  const [fileName, setFileName] = useState("Select CSV");
  const [uploadKey, setUploadKey] = useState(null);
  const [values, setValues] = useState({
    image: "",
  });
  const [loading, setLoading] = useState(false);
  const productCsvSample = process.env.REACT_APP_SERVICES_BULK_IMPORT_SAMPLE;

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleFilesChange = (e) => {
    FileUploadPromise(e[0])
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          setFileName(e[0].name);
          setUploadKey(response?.key);
          setValues({
            ...values,
            image: response?.location,
          });
        }
      })
      .catch((error) => {
        message = error
          ? error !== ""
            ? error
            : "something went wrong"
          : "something went wrong";
        showError();
      });
  };

  const checkFields = () => {
    if (values.image && values.image !== "") {
      return true;
    } else {
      message = "Please enter required data";
      showError();
      return false;
    }
  };

  const importServices = () => {
    if (!checkFields()) return;
    setLoading(true);
    apiJson.imports
      .bulkImport({
        bulk_import: {
          file_name: fileName,
          file_url: values.image,
          key: uploadKey,
          store_id: props.storeId,
          data_type: props.dataType,
        },
      })
      .then((response) => {
        if (response.success) {
          setLoading(false);
          props.createClick();
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
          props.createClick();
        } else {
          setLoading(false);
          props.createClick();
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };
  return (
    <Fragment>
      <div className="service-bulk-modal">
        <div className="service-bulk-header w-100">{props.heading}</div>
        <div className="boday-row w-100">
          <div className="input-group-row w-100 d-flex flex-column">
            <div className="input-row d-flex align-items-center w-100">
              <div className="label">Upload File</div>
              <div className="value">
                <DropzoneElement
                  multiple={false}
                  updateSelectedServiceFiles={handleFilesChange}
                  value={fileName}
                  type={type.CSV}
                />
              </div>
            </div>

            <div className="input-row d-flex align-items-center w-100 download-sample-area">
              <a href={productCsvSample}>Download Sample</a>
            </div>
          </div>
          <div className="buttons-row w-100 d-fex justify-content-start align-items-center">
            <button
              className="cancel-button"
              type="button"
              onClick={props.cancleClick}
            >
              Cancel
            </button>
            <button
              className="create-button"
              type="button"
              onClick={importServices}
              disabled={loading}
            >
              {loading ? (
                <ClipLoader color="#000" loading size={20} />
              ) : (
                "Start Import"
              )}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return { storeId: state?.vendorStore?.vendorStore?.id };
};

export default connect(mapStateToProps)(ServiceBulkImportModal);
